// components/UtmCapture.tsx
'use client'
import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

export default function UtmCapture() {
  const searchParams = useSearchParams()

  useEffect(() => {
    const utmSource = searchParams.get('utm_source')
    const gclid     = searchParams.get('gclid')
    const fbclid    = searchParams.get('fbclid')

    // Only save if there's something worth saving
    if (!utmSource && !gclid && !fbclid) return

    // First-touch: don't overwrite if already set
    const existing = JSON.parse(localStorage.getItem('utmData') ?? '{}')
    if (existing.utm_source || existing.gclid || existing.fbclid) return

    localStorage.setItem('utmData', JSON.stringify({
      utm_source:   utmSource,
      utm_medium:   searchParams.get('utm_medium'),
      utm_campaign: searchParams.get('utm_campaign'),
      utm_content:  searchParams.get('utm_content'),
      utm_term:     searchParams.get('utm_term'),
      gclid,
      fbclid,
      captured_at:  new Date().toISOString(), // useful for debugging
    }))
  }, [searchParams])

  return null
}